const agreementTC = ({date, signDate}) => `
*保險線上申請協議聲明*

*生效日期：${date}*

本*保險線上申請協議*（「本協議」）規範您透過我們網站 https://mut-insurance.com/（「本網站」）使用由 衡安保險顧問公司（「公司」、「我們」、「本公司」或「我們的」）所提供的線上保險申請服務。您（「申請人」、「您」或「您的」）通過本網站提交保險申請，即表示您同意遵守以下條款與條件。

---

### 1. *申請流程*
您確認：
- 線上申請所提供的所有資訊均為正確、完整且真實，並且是您所知的最佳狀態。
- 不完整、誤導或虛假的資訊可能導致申請延遲、被拒或保險保障被取消。
- 提交申請並不保證獲批或保單的簽發。

---

### 2. *申請資格*
- 您必須年滿18歲（或您所在地區的法定成年年齡）才能通過本網站申請保險。
- 未成年人或受扶養人之申請必須由合法授權的成年人提交。

---

### 3. *電子同意*
使用本網站即表示您同意：
- 以電子方式接收所有通訊、披露及保單文件。
- 通過我們加密的平台安全傳送敏感個人及財務資訊。
- 根據適用法律（如ESIGN法案、UETA）使用電子簽名並具有法律效力。

---

### 4. *隱私與資料安全*
- 您的個人資訊將依照我們的 [*隱私政策*](/TandC) 收集、使用及保護，該政策已納入本協議。
- 我們採用業界標準的安全措施保護您的資料；但您知悉任何線上傳輸皆無法保證百分之百安全。

---

### 5. *免責聲明*
- 本公司保留通過第三方來源（如醫療紀錄、信用報告）核實申請資料的權利。
- 申請過程中發生的技術錯誤、中斷或系統故障，非本公司責任。
- 保險保障需在申請獲批且全額保費（如適用）收到後方可生效。

---

### 6. *協議修訂*
我們可能定期更新本協議。您在協議變更後繼續使用本網站，即表示接受修訂後的條款。

---

### 7. *適用法律*
本協議受 香港 法律管轄，任何爭議將由 香港 法院解決。

--- 

*聯絡資訊：*  
如有疑問，請聯絡：  
mutual@mutalins.com.hk / 2385-1896 | 香港九龍油麻地上海街383號華興商業中心9樓A室

---

*勾選下方方框或點擊「提交」即表示您：*
- 確認已閱讀、理解並同意本協議。
- 授權本公司處理您的申請並就您的申請與您聯繫。
*日期：${signDate}*
`;

export default agreementTC;